// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
// Asset Imports

export default function USEmployeeRow() {
   const state = useQuoteContext()
   const { getString } = state
   const permissions = state.featurePermissions['USEmployeesButton']

   if (permissions.includes(state.user_role) || state.hasUSEmployees)
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {getString('product.USEmployeeRow.ProductName')}
            </div>
            <div className='col-bhr2'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.hasUSEmployees}
                  onChange={() => state.setHasUSEmployees((prev) => !prev)}
               ></input>
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
                  {process.env.REACT_APP_ENVIRONMENT == 'staging' && (
                     <div className='col'></div>
                  )}
               </>
            ) : (
               <></>
            )}
         </div>
      )

   return null
}
